import { c as _c } from "react/compiler-runtime";
import { Stack } from '@mui/material';
import { useScrollable } from './useScrollable';
export const ScrollableContent = t0 => {
  const $ = _c(6);
  const {
    children
  } = t0;
  const {
    isScrolledVertically,
    setIsScrolledVertically
  } = useScrollable();
  let t1;
  if ($[0] !== isScrolledVertically || $[1] !== setIsScrolledVertically) {
    t1 = event => {
      const target = event.target as HTMLDivElement;
      if (typeof target.scrollTop === "number") {
        const isScrolled = target.scrollTop > 0;
        if (isScrolled !== isScrolledVertically) {
          setIsScrolledVertically(isScrolled);
        }
      }
    };
    $[0] = isScrolledVertically;
    $[1] = setIsScrolledVertically;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== children || $[4] !== t1) {
    t2 = <Stack flexGrow={1} className="overflow-auto" onScroll={t1}>{children}</Stack>;
    $[3] = children;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};